export const global = {
  intervention: "Intervention",
  interventionPlural: "Interventions",
  interventionTemplate: "Intervention template",
  interventionTemplatePlural: "Intervention templates",
  category: "Category",
  cost: "Cost",
  activityPlural: "Activities",
  add: "Add",
  addGroup: "Add group",
  advancement: "Advancement %",
  alert: "Alert",
  and: "and",
  apiVersion: "API Version",
  appVersion: "UI Version",
  apply: "Apply",
  asset: "Asset",
  assetPlural: "Assets",
  assetType: "Asset type",
  assetTypePlural: "Assets types",
  technicalForm: "Technical form",
  technicalFormPlural: "Technical forms",
  associateEmpty: "Associate",
  associate: "Associate one intervention",
  associate_other: "Associate {{count}} interventions",
  asyncDeleteNotification:
    "The resource and its linked data will be deleted asynchronously. You will receive a notification when the deletion is complete.",
  asyncBatchDeleteNotification:
    "The ressources and theirs linked data will be deleted asynchronously. You will receive a notification when the deletion is complete.",
  pendingDeletion: "Pending deletion",
  batchEdit: {
    label: "Batch edit",
  },
  batchEditSelect: {
    description: "Please select the property to update.",
    label: "Property to be updated",
    placeholder: "Select a property",
  },
  batchDelete: {
    label: "Batch delete",
    message: {
      label:
        "You will delete {{count}} ressource{{plural}} with the batch delete. Check the options below.",
    },
  },
  batchRestore: {
    label: "Batch restore",
  },
  batchTransition: {
    title: "Status",
    noNextStates: "No modification possible",
    stateDisabledTooltip:
      "Batch modification is applicable only for states: {{states}}.",
  },
  table: {
    filter: "Filter",
    reset: "Reset",
    ok: "OK",
  },
  batch: "Batch",
  ok: "OK",
  copy: "Copy",
  copyButton: {
    label: "Copy to clipboard",
    success: "Data copied to clipboard!",
    error: "Failed to copy data",
  },
  cancel: "Cancel",
  close: "Close",
  conditionRating: "Condition rating",
  confirm: "Confirm",
  coordinate: {
    label: "GPS coordinates",
    placeholder: "Coordinates",
  },
  create: "Create",
  date: "Date",
  dataset: "Dataset",
  datasetPlural: "Datasets",
  datasetTypes: {
    cartesian: "Cartesian",
    planPositioning: "Plan positioning",
    file: "File",
    form: "Form",
    gps: "GPS",
    image: "Image",
    images: "Images",
    validation: "Validation",
  },
  days: "{{days}} days ({{date}})",
  delete: "Delete",
  description: "Description",
  discardChanges: "Discard my changes",
  documentViewer: {
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    nextPage: "Next page",
    previousPage: "Previous page",
    backToHighlightPage: {
      observation: "Back to observation",
    },
  },
  done: "Done",
  download: "Download",
  downloadFile: "Download {{fileName}}",
  downloadPicture: "Download picture",
  downloadFailed: "Download failed",
  duplicate: "Duplicate",
  duration: {
    years: "one year",
    years_other: "{{count}} years",
    months: "one month",
    months_other: "{{count}} months",
    yearsAndMonths: "{{years}} and {{months}}",
  },
  dissociate: "Dissociate",
  batchDissociate: "Batch dissociate",
  edit: "Edit",
  email: "Email",
  export: "Export",
  exportFailed: "Export failed",
  files: "Files",
  forms: "Forms",
  format: {
    date: "YYYY-MM-DD",
  },
  geojson: {
    label: "Spatial data (GeoJSON)",
    clientError: "Json is not valid.",
    serverError: 'GeoJSON is not valid: "{{error}}"',
  },
  group: "Group",
  images: "Images",
  info: "Information",
  jsonRootName: "/",
  jsonSyntaxError: "JSON syntax error",
  language: { label: "Language" },
  lastUpdate: "Last update",
  lastViewedAt: "Last viewed at",
  leavePage: "You have updated data.",
  location: "Location",
  locationPlural: "Locations",
  locationOrSector: "Location / Sector",
  manageUserAccess: "Manage user access",
  modulePlural: "Modules",
  name: "Name",
  noData: "No data",
  noGroup: "No group",
  notification: "Notification",
  notificationPlural: "Notifications",
  organization: "Organization",
  filterByOrganization: "Filter by organization",
  organizationPlural: "Organizations",
  otherPlural: "others",
  observation: "Observation",
  observationPlural: "Observations",
  plugin: "Plugin",
  preview: "Preview",
  project: "Project",
  projectPlural: "Projects",
  reference: "Reference",
  reload: "Reload",
  remove: "Remove",
  recommendation: "Recommendation",
  recommendationPlural: "Recommendations",
  restore: "Restore",
  riskMatrix: "Risk matrix",
  save: "Save",
  scheduledDate: "Scheduled date",
  search: "Search",
  sortFields: "Sort fields",
  sortGroups: "Sort groups",
  slogan: "Push decision making forward",
  map: "Map",
  mapClusterCount: "Cluster of {{count}} markers",
  marker: "Position marker",
  list: "List",
  listResetActions: {
    titleWith: "Active filters and sorting",
    titleWithout: "No filters or sorting",
    resetButton: "Reset default filters and sorting",
    deleteButton: "Remove all filters and sorting",
  },
  status: "Status",
  subtype: "Subtype",
  type: "Type",
  unsavedChanges: "You have unsaved changes, are you sure you want to leave?",
  update: "Update",
  upload: {
    button: "Upload",
    authorizedFileTypes: "Accepted file types",
    title: {
      file: "Click or drag 1 file into this area.",
      file_other: "Click or drag files into this area.",
      image: "Click or drag 1 image into this area.",
      image_other: "Click or drag images into this area.",
      photo: "Click or drag 1 photo into this area.",
      photo_other: "Click or drag photos into this area.",
    },
    titleMaxCount: {
      file: "Click or drag files to this area to upload up to {{maxCount}} files.",
      image:
        "Click or drag images to this area to upload up to {{maxCount}} images.",
      photo:
        "Click or drag photos to this area to upload up to {{maxCount}} photos.",
    },
    titleReplace: {
      file: "Click or drag 1 file into this area to replace the selected file.",
      image:
        "Click or drag 1 image into this area to replace the selected image.",
      photo:
        "Click or drag 1 photo into this area to replace the selected photo.",
    },
    error: {
      fileType: "The uploaded file type is not allowed.",
      nameLength: "The uploaded file name is too long: {{fileName}}.",
    },
    maxFileSize: "File size must be smaller than {{maxFileSize}}MB.",
    maxFileSize_other: "Files size must be smaller than {{maxFileSize}}MB.",
  },
  uploadFailed: "Upload has failed",
  uploadFailedVolumeTooLarge:
    "Your upload request contains too much data, please try again by reducing the data volume.",
  upToDate: "Up to date",
  lastModification: "Last modification",
  user: "User",
  userPlural: "Users",
  view: "View",
  customValue: "Type a custom value",
  deleted: "Deleted",
  disassociate: "Disassociate",
  active: "Active",
  statistics: {
    cardClearButton: "reset",
  },
  defaultCauserName: "System",
  addFavorite: "Add to favorites",
  removeFavorite: "Remove from favorites",
  favoriteError: "Unable to update favorites",
  loading: "Loading...",
  listLoadMoreButton: {
    generic: "See more",
    nextPage_one: "See the next {{item}}",
    nextPage_other: "See the next {{count}} {{item}}s",
    total: "{{count}} remaining",
    lastPage_one: "See the last {{item}}",
    lastPage_other: "See the last {{count}} {{item}}s",
  },
  reset: "Reset",
  send: "Send",
  previous: "Previous",
  next: "Next",
  zoomIn: "Zoom in",
  zoomOut: "Zoom out",
  about: {
    title: "About STELAR",
    closeButton: "Close",
  },
  sector: "Sector",
  sectorPlural: "Sectors",
  subSector: "Sub-sector",
  subSectorPlural: "Sub-sectors",
  hierarchy: "Hierarchy",
  helpCenter: {
    tagline: "Need help?",
    button: "Stelar Help Center",
    shortButton: "Support",
    link: "STELAR Help Center",
    shortLink: "Help center",
    articleLink: "For more information, please refer to the help center",
  },
  treeMap: {
    filterByType: {
      location: "Location",
      locationSector: "Location / Sectors",
      sector: "Sectors",
      asset: "Assets",
    },
    subFilter: {
      conditionRating: "Condition rating",
      state: "State",
      assetType: "Asset type",
      location: {
        position: "Position",
        perimeter: "Perimeter",
        area: "Area",
      },
    },
  },
  maintenance: {
    title: "A maintenance operation is currently underway.",
    duration:
      "STELAR will not be accessible during this period: <br /><strong>{{startDate}} to {{endDate}}</strong>.",
    noDuration: "Service will resume as soon as possible.",
    description:
      "This maintenance is essential to ensure <br />the smooth operation of the platform.",
    thanks: "Thank you for your understanding.",
    support:
      "For any questions or assistance, please feel <br />free to contact support.",
  },
  modelLink: {
    activity: "View activity",
    asset: "View asset",
    assettype: "View asset type",
    technicalform: "View technical form",
    comment: "View comment",
    dataset: "View dataset",
    intervention: "View intervention",
    jobmodule: "View module",
    location: "View location",
    observation: "View observation",
    organization: "View organization",
    project: "View project",
    recommendation: "View recommendation",
    sector: "View sector",
    severitygrid: "View severity grid",
    template: "View intervention template",
    user: "View user",
  },
  document: "Document",
  documentPlural: "Documents",
  informationSection: {
    info: "Information",
    warning: "Warning",
  },
  details: "Details",
  state: "State",
  logoAlt: "{{name}} logo",
  id: "Id",
};
